export default {"src":"/_next/static/media/fbaa_01.9482eb43.svg","height":56,"width":132,"blurWidth":0,"blurHeight":0};